import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom";
import { changeIndex, emptyGallery } from "../redux/gallerySlice";
import { useEffect } from "react";

const PhotosGallery = () => {
    const { array, indexShowed, activityId } = useSelector(state => state.gallery);

    useEffect(() => {
        if(!activityId) handleBackLink()
    }, [activityId])

    // Gestisco il ritorno alla pagina ActivityDetails
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleBackLink = () => {
        if(activityId) {
            navigate(`/activity-details?id=${activityId}`);
        } else {
            navigate('/handle-activities')
        }
        dispatch(emptyGallery());
    }

    return (
        <div className="bg-neutral-100 flex flex-col items-center p-4 overflow-y-auto">
            <div className="rounded-xl flex flex-col gap-4 w-full max-w-[1400px]">

                {/* Image */}
                {
                    array &&
                    <div className="relative w-full flex justify-center">
                        {/* Close icon */}
                        <div className={`absolute top-2 right-2 text-[#225424] w-fit rounded-xl cursor-pointer pt-2 pb-0.5 px-2 bg-white`} onClick={() => handleBackLink()}>
                            <i className="fi fi-rr-circle-xmark text-xl"></i>
                        </div>
                        
                        <img src={array[indexShowed].secure_url} className="rounded-xl" />
                    </div>
                }

                {/* Slide */}
                <div className="flex gap-2 p-2 rounded-xl mx-2 overflow-x-auto">
                    {
                        array && array.map((element, index) => {
                            return <div className="min-w-[100px] h-[100px] md:min-w-[200px] md:h-[200px] overflow-hidden"><img key={index} src={element.resizedUrl} alt={element.public_id} className="w-full h-full rounded-xl md:cursor-pointer" onClick={() => dispatch(changeIndex(index))} /></div>
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default PhotosGallery